import React, { FC, useEffect, useState } from "react";
import { Form, Table, Typography } from "antd";
import type { ColumnGroupType, ColumnType, ColumnsType } from "antd/es/table";
import {
  GetOrderDetailData,
  GetPrepareShipResponseData,
  GetPrepareShipResponseOrder,
  GetTransportShipedOrderdata,
  GetTransportShipedResponseData,
  GetTransportShippedDetailData,
} from "services/interface";
import { formatDate, formatDateWithTime } from "utils/dateFormat";

import ModalOderDetail from "./ModalOrderDetail";
// import { useGetOrderDetail } from "hooks/useOrders";
import { useAppDispatch, useAppSelector } from "../../../store";
import { setLoading } from "store/slices/loadingSlice";

import ExportToExcel from "./ExportToExcel";
import {
  useGetTransportOrderDetail,
  useGetTransportShippedDetail,
} from "hooks/useShipping";
import {
  setDataTransportSuccessLimit,
  setDataTransportSuccessOffset,
} from "store/slices/orderSlice";
import { useGetOrderDetail } from "hooks/useOrders";

interface OrderTableListProps {
  data?: GetTransportShipedResponseData;
  IsHiddenPersonInfo?: boolean;
  refetchData: () => void;
  childrenBank: React.ReactNode[];
  refetchPrepare?: () => void;
}

const OrderTableList: FC<OrderTableListProps> = ({
  data,
  IsHiddenPersonInfo,
  refetchData,
  childrenBank,
  refetchPrepare,
}) => {
  const [form] = Form.useForm();
  const [modalVisibility, setModalVisibility] = useState<{
    [key: string]: boolean;
  }>({});

  const dispatch = useAppDispatch();
  const offset = useAppSelector(
    (state) => state.order.dataTransportSuccess.offset
  );
  const limit = useAppSelector(
    (state) => state.order.dataTransportSuccess.limit
  );

  const [refId, setRefId] = useState<string>("");
  const [showEdit, setShowEdit] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(Math.floor(offset / limit) + 1);
  }, [offset, limit]);

  const showEditModal = (order_id: string, ref_id: string) => {
    setShowEdit(true);
    setRefId(ref_id);
    console.log(order_id);
  };

  const [modalData, setModalData] = useState<GetTransportShippedDetailData>();

  const [oderDetail, setOderDetail] = useState<GetOrderDetailData>();

  const { mutateAsync } = useGetTransportShippedDetail();

  const { mutateAsync: oderDetailMutate } = useGetOrderDetail();

  const [isProductProblem, setIsProductProblem] = useState<boolean>(false);

  const showDrawer = (order_id: string) => {
    setModalVisibility((prev) => ({
      ...prev,
      [order_id]: true,
    }));
  };

  const columns: ColumnsType<GetTransportShipedOrderdata> = [
    {
      title: "Order No.",
      dataIndex: "order_code",
      key: "order_id",
      width: "200px",
      fixed: "left",
      render: (_text, record) => {
        return (
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline",
            }}
            type="secondary"
            onClick={ async() => {
              dispatch(setLoading(true));

              await mutateAsync(
                {
                  order_id: record.order_id,
                  status: "complete",
                },
                {
                  onSuccess: async (data) => {
                    setModalData(data.data[0]);

                    // setIsProductProblem(record.is_problem);

                    await new Promise((resolve) => setTimeout(resolve, 200));
                  },
                  onError: (error: any) => {
                    console.log(error);
                    dispatch(setLoading(false));
                  },
                }
              );

              await oderDetailMutate(
                {
                  key_type: "order_id",
                  group_by: "factory",
                  items: [record.order_id],
                },
                {
                  onSuccess: (data) => {
                    setOderDetail(data.data[0]);
                  },
                  onError: (error) => {
                    console.log(error);
                    dispatch(setLoading(false));
                  },
                }
              );

              dispatch(setLoading(false));

              setShowDetail(true);
            }}
          >
            {_text}
          </Typography.Link>
        );
      },
    },
    {
      title: "วันที่สั่งซื้อ",
      dataIndex: "order_date",
      width: "100px",
      render: (_text) => {
        return <Typography.Text>{formatDateWithTime(_text)}</Typography.Text>;
      },
    },
    {
      title: "วันที่จัดส่ง",
      dataIndex: "due_date",
      width: 200,
      render: (_text) => <Typography.Text>{formatDate(_text)}</Typography.Text>,
    },
    {
      title: "ประเภทการจัดส่ง",
      dataIndex: "transport_type_name",
      key: "transport_type_name",
      width: "200px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    // {
    //   title: "สถานี",
    //   dataIndex: "station_ship",
    //   key: "station_ship",
    //   width: "200px",

    //   render: (_text) => {
    //     return <Typography.Text>{_text}</Typography.Text>;
    //   },
    // },
    // {
    //   title: "ประเภทขนส่ง",
    //   dataIndex: "bus_name",
    //   key: "bus_name",
    //   width: "200px",

    //   render: (_text) => {
    //     return <Typography.Text>{_text}</Typography.Text>;
    //   },
    // },
    {
      title: "บริษัท",
      dataIndex: "brand_name",
      key: "brand_name",
      width: "200px",

      render: (_text, record) => {
        return <Typography.Text>{
            record?.transport_type === "post_office" ? _text : record?.bus_name
          }</Typography.Text>;
      },
    },
    {
      title: "เลข Tracking",
      dataIndex: "postal_code",
      key: "postal_code",
      width: "200px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "ชื่อผู้รับสินค้า",
      dataIndex: "address_name",
      key: "address_name",
      width: "200px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "เบอร์โทรศัพท์",
      dataIndex: "address_telephone",
      key: "address_telephone",
      width: "130px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "จังหวัด",
      dataIndex: "province_name",
      key: "province_name",
      width: "150px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "อำเภอ",
      dataIndex: "district_name",
      key: "district_name",
      width: "150px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    // {
    //   title: "ที่อยู่",
    //   dataIndex: "address_text",
    //   key: "address_text",
    //   width: 60,
    //   render: (_text) => {
    //     return <Typography.Text>{_text}</Typography.Text>;
    //   },
    // },
  ];

  let filtersColumns: (
    | ColumnGroupType<GetTransportShipedOrderdata>
    | ColumnType<GetTransportShipedOrderdata>
  )[] = columns;
  if (IsHiddenPersonInfo) {
    filtersColumns = columns.filter(
      (column) => column.key !== "ref_name" && column.key !== "ref_telephone"
    );
  }
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          marginBottom: 16,
        }}
      >
        <div style={{ flex: 1 }}></div>
        <div
          style={{
            marginTop: "32px",
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {/* <ExportToExcel /> */}
        </div>
      </div>
      <Table
        // onRow={(record) => {
        //   return {
        //     onClick: () => {
        //       setShowDetail(true);
        //     },
        //   };
        // }}

        rowKey="key"
        size="small"
        // rowSelection={rowSelection}
        columns={filtersColumns}
        scroll={{ y: 600, x: true }}
        dataSource={data?.order_data}
        pagination={{
          current: currentPage,
          pageSize: limit,
          total: parseInt(data?.total_record as string),
          onChange: (page, pageSize) => {
            dispatch(setDataTransportSuccessOffset(pageSize! * (page! - 1)));
            dispatch(setDataTransportSuccessLimit(pageSize!));
          },
        }}
      />
      <ModalOderDetail
        open={showDetail}
        onClose={() => {
          setShowDetail(false);
        }}
        item={modalData as GetTransportShippedDetailData}
        childrenBank={childrenBank}
        refetchData={refetchData}
        statusPage="new_order"
        showEditModal={showEditModal}
        isProductProblem={isProductProblem}
        oderDetail={oderDetail}
      />
    </div>
  );
};

export default OrderTableList;
